import axios from "axios";
import React, { useState } from "react";

function AnaSayfa() {

  const [loginType, setLoginType] = useState("")

  function login(e,type) {
    e.preventDefault();
    e.target[2].innerHTML = "<i class='fa-solid fa-spinner fa-spin'></i>";
    axios
      .post("/login", {
        nick: e.target[0].value,
        pass: e.target[1].value,
        type: type,
      })
      .then((res) => {
        console.log(res);
        if (res.data == "no") {
          alert("Giriş bilgileriniz hatalı");
          e.target[1].value = ""
          e.target[2].innerHTML = type == "okul" ? "Kantin Girişi" : "Veli Girişi"
          return;
        }
        if (type== "okul") {
          localStorage.okul_id = res.data;
          window.location.reload();
        }

        if (type == "veli") {
          localStorage.veli_id = res.data;
          window.location.reload();
        }
      });
  }

  
  return (
    <div className="screen pb-5">
      <div className="login-big-box">
        <div className="flex justify-between ">
          <div className="pbox pbox-turuncu flex flex-column items-center justify-center">
            {
              loginType != "okul" ? <>
                <svg
              width="66"
              height="66"
              viewBox="0 0 66 66"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.7185 34.103H13.0688C12.4994 34.103 12.0376 34.5647 12.0376 35.1343V42.1093C12.0376 42.6788 12.4994 43.1406 13.0688 43.1406H17.7185C18.2881 43.1406 18.7498 42.6788 18.7498 42.1093V35.1343C18.7498 34.5647 18.2881 34.103 17.7185 34.103ZM16.6873 41.0781H14.1001V36.1655H16.6873V41.0781Z"
                fill="#F2740D"
              />
              <path
                d="M29.3438 34.103H24.6936C24.1241 34.103 23.6624 34.5647 23.6624 35.1343V42.1093C23.6624 42.6788 24.1241 43.1406 24.6936 43.1406H29.3438C29.9133 43.1406 30.3751 42.6788 30.3751 42.1093V35.1343C30.3751 34.5647 29.9133 34.103 29.3438 34.103ZM28.3126 41.0781H25.7249V36.1655H28.3126V41.0781Z"
                fill="#F2740D"
              />
              <path
                d="M40.9684 34.103H36.3188C35.7493 34.103 35.2876 34.5647 35.2876 35.1343V42.1093C35.2876 42.6788 35.7493 43.1406 36.3188 43.1406H40.9684C41.538 43.1406 41.9997 42.6788 41.9997 42.1093V35.1343C41.9997 34.5647 41.538 34.103 40.9684 34.103ZM39.9372 41.0781H37.3501V36.1655H39.9372V41.0781Z"
                fill="#F2740D"
              />
              <path
                d="M52.5937 34.103H47.9435C47.374 34.103 46.9122 34.5647 46.9122 35.1343V42.1093C46.9122 42.6788 47.374 43.1406 47.9435 43.1406H52.5937C53.1632 43.1406 53.625 42.6788 53.625 42.1093V35.1343C53.625 34.5647 53.1632 34.103 52.5937 34.103ZM51.5625 41.0781H48.9747V36.1655H51.5625V41.0781Z"
                fill="#F2740D"
              />
              <path
                d="M64.9688 62.3405H59.8125V28.3093C59.8125 27.7398 59.3507 27.278 58.7812 27.278H51.8088V20.0668C51.8088 20.0364 51.794 20.0109 51.7913 19.9812C51.7848 19.9022 51.7697 19.8282 51.7455 19.7541C51.7295 19.7043 51.7139 19.657 51.6907 19.6107C51.6569 19.5431 51.6135 19.4844 51.566 19.4257C51.5336 19.386 51.5054 19.3457 51.4674 19.3113C51.412 19.2605 51.347 19.2233 51.2806 19.1852C51.2352 19.1591 51.1946 19.1289 51.1453 19.1099C51.1329 19.105 51.1239 19.0953 51.1113 19.091L33.2089 12.9619V10.8554C34.8792 11.1532 36.5259 11.3093 38.1402 11.3093C40.1639 11.3093 42.1387 11.0746 44.0482 10.6058C44.5094 10.4926 44.8337 10.0791 44.8337 9.60425V2.62928C44.8337 2.3296 44.7032 2.04518 44.4767 1.84925C44.2506 1.65341 43.949 1.56225 43.6534 1.60907C39.5365 2.21029 35.7357 2.21286 32.3574 1.6136C32.3288 1.60835 32.3012 1.6199 32.2725 1.61711C32.2397 1.61402 32.2113 1.59803 32.1777 1.59803C32.1266 1.59803 32.0828 1.6199 32.0337 1.62711C31.9704 1.63629 31.9106 1.6433 31.8502 1.66424C31.7659 1.6928 31.6933 1.73601 31.6205 1.78407C31.587 1.80624 31.5462 1.81305 31.515 1.83924C31.5041 1.84842 31.5 1.86286 31.4896 1.87245C31.4145 1.94061 31.3587 2.02353 31.3064 2.11087C31.2857 2.14573 31.2558 2.17326 31.2393 2.21029C31.1817 2.33899 31.1464 2.47924 31.1464 2.62928V9.60425V12.9619L13.2436 19.091C13.231 19.0953 13.2221 19.105 13.2096 19.1099C13.1603 19.1289 13.1198 19.1591 13.0744 19.1852C13.008 19.2233 12.9428 19.2605 12.8874 19.3113C12.8496 19.3457 12.8212 19.386 12.7889 19.4257C12.7413 19.4844 12.698 19.5431 12.6643 19.6107C12.641 19.657 12.6255 19.7043 12.6094 19.7541C12.5852 19.8282 12.5701 19.9022 12.5636 19.9812C12.5609 20.0109 12.5462 20.0364 12.5462 20.0668V27.278H7.21875C6.64919 27.278 6.1875 27.7398 6.1875 28.3093V62.3405H1.03125C0.461691 62.3405 0 62.8018 0 63.3718C0 63.9418 0.461691 64.403 1.03125 64.403H7.21875H24.75H41.25H58.7812H64.9688C65.5382 64.403 66 63.9418 66 63.3718C66 62.8018 65.5382 62.3405 64.9688 62.3405ZM14.6087 25.2155H49.7463V27.1733H14.6087V25.2155ZM49.7463 23.153H14.6087V21.098H49.7463V23.153ZM42.7712 3.80749V8.78048C39.7409 9.40686 36.5318 9.40233 33.2089 8.7644V3.83316C36.1521 4.22999 39.3592 4.22143 42.7712 3.80749ZM32.1777 14.7893L44.5814 19.0355H19.7735L32.1777 14.7893ZM25.7812 62.3405V49.9655H31.9688V62.3405H25.7812ZM34.0312 62.3405V49.9655H40.2188V62.3405H34.0312ZM42.2812 62.3405V48.9343C42.2812 48.3648 41.8195 47.903 41.25 47.903H24.75C24.1804 47.903 23.7188 48.3648 23.7188 48.9343V62.3405H8.25V29.3405H57.75V62.3405H42.2812Z"
                fill="#F2740D"
              />
            </svg>

            <p className="font-medium text-center lh-1 mt-3 mb-3">
              Satış, stok takibi, ürün yönetimi, öğrenci yönetimi için
              kantin girişi.{" "}
            </p>
            <button onClick={()=>{setLoginType("okul")}} className="font-medium text-lg text-white b-hover">
            Kantin Girişi
            </button>
              </> : <>
              <form onSubmit={e=>login(e,"okul")}>
                <div className="font-medium pri">Kantin Girişi</div>
                  <div className="row">
                    <div className="col-12">
                        <div>
                        <label htmlFor="" className="font-medium">
                    Kullanıcı Adı
                  </label>
                  <input
                    required
                    type="text"
                    className="bg-slate-100 font-medium w-100 d-block p-2 rounded border"
                    placeholder={"Kullanıcı Adı"}
                  />
                        </div>
                    </div>

                    <div className="col-12">
                        <div>
                        <label htmlFor="" className="font-medium">
                    Şifre
                  </label>
                  <input
                    required
                    type="password"
                    className="bg-slate-100 font-medium w-100 d-block p-2 rounded border"
                    placeholder={"Şifre"}
                  />
                        </div>
                    </div>
                  </div>

                  <button type="submit" className="font-medium mt-1  text-white">Giriş Yap</button>
              </form>
              </>
            }
          
          </div>
          <div className="pbox pbox-mavi flex flex-column items-center justify-center">
           {
            loginType != "veli" ?
            <>
             <svg
              width="97"
              height="61"
              viewBox="0 0 97 61"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M88.1254 40.5503L88.0713 31.2669L97 26.2706L48.3668 0.622513L0 26.7836L19.3916 37.9172L19.4302 44.5329L19.4342 45.0612L19.6113 44.9764C19.4069 45.2538 19.2759 45.5391 19.2799 45.8244C19.2953 49.0781 32.4299 51.6532 48.6411 51.5648C64.8444 51.48 77.9596 48.7546 77.9482 45.5083C77.9482 45.223 77.7978 44.9456 77.5974 44.6603L77.7746 44.7452V44.2168L77.7398 37.5744L86.1481 32.3429L86.1943 40.5622C85.2689 40.9591 84.6254 41.869 84.6329 42.9332C84.6408 44.3289 85.774 45.4582 87.1811 45.4467C88.5961 45.4389 89.7179 44.2977 89.71 42.906C89.7021 41.8418 89.0546 40.9398 88.1254 40.5503ZM48.6292 49.3247C34.2458 49.4056 22.5798 47.8249 22.5684 45.809C22.5569 43.7926 34.2071 42.1003 48.591 42.0269C62.9784 41.946 74.6404 43.5188 74.6483 45.5312C74.6593 47.54 63.0166 49.2478 48.6292 49.3247ZM77.0765 32.1847C75.1297 30.1376 68.1518 24.7325 48.4982 24.8446C28.8174 24.9488 21.9284 30.4193 20.0047 32.4972L19.9933 30.5389C19.9933 30.5389 25.5755 22.0458 48.4832 21.9262C71.3791 21.8027 77.0655 30.2303 77.0655 30.2303L77.0765 32.1847ZM85.134 46.0015L84.1432 60.3775C87.2079 55.5624 89.768 57.355 89.768 57.355L89.7065 45.9783C86.4136 47.2701 85.134 46.0015 85.134 46.0015Z"
                fill="#0A95FF"
              />
            </svg>

            <p className="font-medium text-center lh-1 mt-3 mb-3">
              Öğrencinizin yemek izinlerini bakiyesini ve sipariş takibini
              yapabilirsiniz
            </p>
            <button onClick={()=>{setLoginType("veli")}} className="font-medium text-lg text-white b-hover">
              Veli Girişi
            </button></> : <>
            <form onSubmit={e=>login(e,"veli")}>
                <div className="font-medium pri">Veli Girişi</div>
                  <div className="row">
                    <div className="col-12">
                        <div>
                        <label htmlFor="" className="font-medium">
                   Öğrenci TC
                  </label>
                  <input
                    required
                    type="text"
                    className="bg-slate-100 font-medium w-100 d-block p-2 rounded border"
                    placeholder={"Öğrenci TC"}
                  />
                        </div>
                    </div>

                    <div className="col-12">
                        <div>
                        <label htmlFor="" className="font-medium">
                    Öğrenci Okul Numarası
                  </label>
                  <input
                    required
                    type="text"
                    className="bg-slate-100 font-medium w-100 d-block p-2 rounded border"
                    placeholder={"Öğrenci Okul Numarası"}
                  />
                        </div>
                    </div>
                  </div>

                  <button type="submit" className="font-medium mt-1  text-white">Giriş Yap</button>
              </form></>
           }
          </div>
        </div>

        <div className="mx-auto mt-5">
          <div className="tanitim-text pt-5 text-center text-white font-bold lg:text-5xl">
            Bulut tabanlı <span className="text-primary">kantin</span> satış<br/> yönetim sistemi
          </div>

          <button onClick={e=>window.location = "https://themaestro.com.tr/"} target="_blank" className="button px-5 py-2 text-xl mx-auto d-block mt-4">Detay</button>

          <div className="text-center flex justify-center mt-4">
            <div className="mr-5">
              <div className="text-white font-medium text-2xl text-center">200+</div>
              <div className="text-slate-400 font-medium lh-1 text-lg text-center">Okul</div>
            </div>

            <div className="ml-5">
              <div className="text-white font-medium text-2xl text-center">13.000+</div>
              <div className="text-slate-400 font-medium lh-1 text-lg text-center">Öğrenci</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AnaSayfa;
